module.exports = __webpack_public_path__ + "static/media/coquille.1d4ed904.png";